var map = {
	"./541d2506-9363-4c8b-8646-cfbf6fa7031e.pdf": 2261,
	"./573775ba-db66-4d5c-823f-09dfa78db616.pdf": 2262,
	"./6e063bce-ead8-43d7-9bc6-4e322be4e885.pdf": 2263,
	"./COLA2018001.pdf": 2264,
	"./COLA2018002.pdf": 2265,
	"./COLA2018003.pdf": 2266,
	"./COLA2018004.pdf": 2267,
	"./COLA2018005.pdf": 2268,
	"./COLA2018006.pdf": 2269,
	"./COLA2018007.pdf": 2270,
	"./COLA2018008.pdf": 2271,
	"./Chapter.pdf": 2272,
	"./c7da8588-5302-43fa-9200-368b6ba96eba.pdf": 2273,
	"./doc.pdf": 2274
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2260;


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles ^\.\/.*$
// module id = 2260
// module chunks = 1